/* Carousel.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["displayCarousel"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["displayCarousel"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["active"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["displayCarousel"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["transitionTimerInMs"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["displayCarousel"],
  _excluded15 = ["as", "style"],
  _excluded16 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _90 = "._1ygbi70q:focus-visible{outline:var(--_wdxe65)}";
const _89 = "._4t3ixy5q{height:var(--ds-space-400,2pc)}";
const _88 = "._1bsbxy5q{width:var(--ds-space-400,2pc)}";
const _87 = "._lcxv1rj4{pointer-events:all}";
const _86 = "._19it1eso{border:var(--_1m4nn1n)}";
const _85 = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
const _84 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const _83 = "._i0dl1osq{flex-basis:100%}";
const _82 = "._1o9zidpf{flex-shrink:0}";
const _81 = "._16jlidpf{flex-grow:0}";
const _80 = "._4cvr1y6m{align-items:flex-start}";
const _79 = "._2lx21bp4{flex-direction:column}";
const _78 = "._p12f1n7t{max-width:72rem}";
const _77 = "._1yt4s373{padding:var(--ds-space-050,4px) var(--ds-space-050,4px)}";
const _76 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _75 = "._18u01wug{margin-left:auto}";
const _74 = "._otyridpf{margin-bottom:0}";
const _73 = "._2hwx1wug{margin-right:auto}";
const _72 = "._19pkidpf{margin-top:0}";
const _71 = "._18m9ewfl{overflow-y:visible}";
const _70 = "._1reoewfl{overflow-x:visible}";
const _69 = "._18m915vq{overflow-y:hidden}";
const _68 = "._1reo15vq{overflow-x:hidden}";
const _67 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz8zq2{padding:var(--ds-space-400,2pc) var(--ds-space-500,40px)}._1gnkgntw{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1440\" height=\"435\" viewBox=\"0 0 1440 435\" fill=\"none\"><path d=\"M0 434.5V0.5H994V412.292L0 434.5Z\" fill=\"%23F0F1F2\"/><path d=\"M1440 400.871V0.5H838V380.385L1440 400.871Z\" fill=\"%23F0F1F2\"/></svg>')}._8m2k1bp4{flex-direction:column}}";
const _66 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn8zq2{padding:var(--ds-space-400,2pc) var(--ds-space-500,40px)}._gkkoyzw1{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"768\" height=\"409\" viewBox=\"0 0 768 409\" fill=\"none\"><path d=\"M0 408.5V0.5H582V387.623L0 408.5Z\" fill=\"%23F0F1F2\"/><path d=\"M768 376.886V0.5H183V357.626L768 376.886Z\" fill=\"%23F0F1F2\"/></svg>')}._55br1bp4{flex-direction:column}}";
const _65 = "@media (min-width:30rem) and (max-width:47.99rem){._pbwr8zq2{padding:var(--ds-space-400,2pc) var(--ds-space-500,40px)}._1glwyzw1{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"768\" height=\"409\" viewBox=\"0 0 768 409\" fill=\"none\"><path d=\"M0 408.5V0.5H582V387.623L0 408.5Z\" fill=\"%23F0F1F2\"/><path d=\"M768 376.886V0.5H183V357.626L768 376.886Z\" fill=\"%23F0F1F2\"/></svg>')}._bpkw1bp4{flex-direction:column}}";
const _64 = "@media not all and (min-width:30rem){._1jj01ejb{padding:var(--ds-space-300,24px)}._1wm0u2gc{gap:var(--ds-space-100,8px)}._1mfrbis2{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"375\" height=\"539\" viewBox=\"0 0 375 539\" fill=\"none\"><path d=\"M0 538.5V0.5H284V510.971L0 538.5Z\" fill=\"%23F0F1F2\"/><path d=\"M375 496.813V0.5H89V471.417L375 496.813Z\" fill=\"%23F0F1F2\"/></svg>')}._14q21bp4{flex-direction:column}}";
const _63 = "._1itkgntw{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1440\" height=\"435\" viewBox=\"0 0 1440 435\" fill=\"none\"><path d=\"M0 434.5V0.5H994V412.292L0 434.5Z\" fill=\"%23F0F1F2\"/><path d=\"M1440 400.871V0.5H838V380.385L1440 400.871Z\" fill=\"%23F0F1F2\"/></svg>')}";
const _62 = "._1lrw1dfr{background-size:cover}";
const _61 = "._ouxlyfq0{background-position:bottom}";
const _60 = "._12vemgnk{background-repeat:no-repeat}";
const _59 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const _58 = "._p12f1g4v{max-width:108rem}";
const _57 = "._kqswh2mm{position:relative}";
const _56 = "._1yt450w7{padding:var(--ds-space-500,40px) 0}";
const _55 = "._1bsb1osq{width:100%}";
const _54 = "._v5641m16{transition:var(--_vz31bp)}";
const _53 = "._1e0c1ule{display:block}";
const _52 = "@media not all and (min-width:64rem){._1mjbglyw{display:none}}";
const _51 = "._tdrqpxbi:focus-visible{margin-top:var(--ds-space-200,1pc)}";
const _50 = "._19lvkb7n:focus-visible{opacity:1}";
const _49 = "._146g1wug:focus-visible{height:auto}";
const _48 = "._1ejj1cd0:focus-visible{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _47 = "._hx7m1pyq:focus-visible{padding:var(--ds-space-100,8px) var(--ds-space-200,1pc)}";
const _46 = "._1gly1wug:focus-visible{margin-left:auto}";
const _45 = "._1wsjidpf:focus-visible{margin-bottom:0}";
const _44 = "._1nft1wug:focus-visible{margin-right:auto}";
const _43 = "._tdrqidpf:focus-visible{margin-top:0}";
const _42 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _41 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _40 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _39 = "._1ygbi3y1:focus-visible{outline:var(--ds-space-025,2px) solid var(--ds-border-focused,#388bff)}";
const _38 = "._tzy4idpf{opacity:0}";
const _37 = "._4t3iidpf{height:0}";
const _36 = "._bfhk18uv{background-color:initial}";
const _35 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _34 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _33 = "._y3gn1h6o{text-align:center}";
const _32 = "._syaz14q2{color:var(--ds-link,#0c66e4)}";
const _31 = "@media not all and (min-width:30rem){._1m0aglyw{display:none}}";
const _30 = "._1pbycs5v{z-index:2}";
const _29 = "._lcxvglyw{pointer-events:none}";
const _28 = "._1bahesu3{justify-content:flex-end}";
const _27 = "._4t3i1osq{height:100%}";
const _26 = "._1bsbdjo9{width:calc(100% - var(--ds-space-200, 1pc)*2)}";
const _25 = "._18s8119w{margin:0 var(--ds-space-200,1pc)}";
const _24 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _23 = "._bfhk1oju{background-color:var(--ds-icon-subtle,#626f86)}";
const _22 = "._bfhk1qo3{background-color:var(--ds-icon-selected,#0c66e4)}";
const _21 = "._1e0c1o8l{display:inline-block}";
const _20 = "._80omtlke{cursor:pointer}";
const _19 = "._4t3iu2gc{height:var(--ds-space-100,8px)}";
const _18 = "._1bsbu2gc{width:var(--ds-space-100,8px)}";
const _17 = "._19itglyw{border:none}";
const _16 = "._19bvidpf{padding-left:0}";
const _15 = "._n3tdidpf{padding-bottom:0}";
const _14 = "._u5f3idpf{padding-right:0}";
const _13 = "._ca0qidpf{padding-top:0}";
const _12 = "._18s8otz2{margin:0 var(--ds-space-050,4px)}";
const _11 = "._2rko1ssb{border-radius:50%}";
const _10 = "._1e0cglyw{display:none}";
const _9 = "._1e0c1txw{display:flex}";
const _8 = "._1wpz1fhb{align-self:stretch}";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "._1bah1h6o{justify-content:center}";
const _5 = "._1yt4iaxp{padding:var(--ds-space-050,4px) var(--ds-space-0,0)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { media } from '@atlaskit/primitives/responsive';
import { ACTION_SUBJECT_ID_AUTO_SCROLL, ACTION_SUBJECT_ID_DOT, ACTION_SUBJECT_ID_NEXT_BUTTON, ACTION_SUBJECT_ID_PREV_BUTTON, ACTION_SUBJECT_ID_SLIDE, ACTION_SUBJECT_ID_SWIPE_LEFT, ACTION_SUBJECT_ID_SWIPE_RIGHT, CarouselClickEvent, CarouselSlideViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BodyNormal } from '../Typography';
// SVG backgrounds encoded as data URIs so they can be used directly in CSS background-image
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "@media (min-width:64rem){._zp81ewfl{overflow-x:visible}._1mbpewfl{overflow-y:visible}}";
const _3 = "@media (min-width:64rem){._zp8115vq{overflow-x:hidden}._1mbp15vq{overflow-y:hidden}}";
const _2 = "@media (min-width:64rem){}";
const CAROUSEL_BG_DESKTOP = 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1440" height="435" viewBox="0 0 1440 435" fill="none"><path d="M0 434.5V0.5H994V412.292L0 434.5Z" fill="%23F0F1F2"/><path d="M1440 400.871V0.5H838V380.385L1440 400.871Z" fill="%23F0F1F2"/></svg>\')';
const CAROUSEL_BG_TABLET = 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="768" height="409" viewBox="0 0 768 409" fill="none"><path d="M0 408.5V0.5H582V387.623L0 408.5Z" fill="%23F0F1F2"/><path d="M768 376.886V0.5H183V357.626L768 376.886Z" fill="%23F0F1F2"/></svg>\')';
const CAROUSEL_BG_MOBILE = 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="375" height="539" viewBox="0 0 375 539" fill="none"><path d="M0 538.5V0.5H284V510.971L0 538.5Z" fill="%23F0F1F2"/><path d="M375 496.813V0.5H89V471.417L375 496.813Z" fill="%23F0F1F2"/></svg>\')';
const SLIDE_TRANSITION_TIME_IN_MS = 300;
export const CarouselContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["", __cmplp.displayCarousel ? "_zp8115vq _1mbp15vq" : "_zp81ewfl _1mbpewfl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CarouselContainer.displayName = 'CarouselContainer';
}
export const PaginationDots = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4iaxp _1bah1h6o _4cvr1h6o _1wpz1fhb", __cmplp.displayCarousel ? "_1e0c1txw" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PaginationDots.displayName = 'PaginationDots';
}
export const Dot = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded5);
  const {
      active
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1ssb _18s8otz2 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _1bsbu2gc _4t3iu2gc _80omtlke _1e0c1o8l", __cmplp.active ? "_bfhk1qo3" : "_bfhk1oju", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Dot.displayName = 'Dot';
}
export const ArrowsContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_24, _25, _9, _7, _26, _27, _28, _29, _30, _31]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _18s8119w _1e0c1txw _4cvr1h6o _1bsbdjo9 _4t3i1osq _1bahesu3 _lcxvglyw _1pbycs5v _1m0aglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ArrowsContainer.displayName = 'ArrowsContainer';
}
export const FocusButtonText = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21, _32, _33, _34]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _syaz14q2 _y3gn1h6o _19pku2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FocusButtonText.displayName = 'FocusButtonText';
}
export const FocusButton = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded9);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _35, _34, _36, _20, _33, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _2rkou2gc _19pku2gc _bfhk18uv _80omtlke _y3gn1h6o _4t3iidpf _tzy4idpf _1ygbi3y1 _vjfr18uv _10xfglyw _1w0vnqa1 _tdrqidpf _1nft1wug _1wsjidpf _1gly1wug _hx7m1pyq _1ejj1cd0 _146g1wug _19lvkb7n _tdrqpxbi _1mjbglyw", __cmplp.displayCarousel ? "_1e0c1ule" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FocusButton.displayName = 'FocusButton';
}
const ArrowButtonStyle = null;
const CardsWrapper = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded11);
  const {
      transitionTimerInMs
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_54, _9, _55]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_vz31bp": ix("transform ".concat(__cmplp.transitionTimerInMs, "ms ease-in-out"))
      }),
      ref: __cmplr,
      className: ax(["_v5641m16 _1e0c1txw _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardsWrapper.displayName = 'CardsWrapper';
}
const CarouselContainerStyle = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded13);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_56, _57, _55, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt450w7 _kqswh2mm _1bsb1osq _p12f1g4v _bfhkvuon _12vemgnk _ouxlyfq0 _1lrw1dfr _1itkgntw _1jj01ejb _1wm0u2gc _1mfrbis2 _14q21bp4 _pbwr8zq2 _1glwyzw1 _bpkw1bp4 _13zn8zq2 _gkkoyzw1 _55br1bp4 _1acz8zq2 _1gnkgntw _8m2k1bp4", __cmplp.displayCarousel ? "_1reo15vq _18m915vq" : "_1reoewfl _18m9ewfl", __cmplp.className])
    }))]
  });
});

// Inner content wrapper to constrain max width while background spans full width
if (process.env.NODE_ENV !== 'production') {
  CarouselContainerStyle.displayName = 'CarouselContainerStyle';
}
const CarouselContentStyle = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded15);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_72, _73, _74, _75, _76, _68, _69, _77, _55, _78, _9, _79, _80]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp1b66 _1reo15vq _18m915vq _1yt4s373 _1bsb1osq _p12f1n7t _1e0c1txw _2lx21bp4 _4cvr1y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CarouselContentStyle.displayName = 'CarouselContentStyle';
}
const CardContainerStyle = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded16);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_81, _82, _83]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlidpf _1o9zidpf _i0dl1osq", __cmplp.className])
    }))]
  });
});

// SpotlightSlideWrapper removed – styles moved to CarouselContainerStyle
if (process.env.NODE_ENV !== 'production') {
  CardContainerStyle.displayName = 'CardContainerStyle';
}
export const useCarouselNavigation = (itemsLength, itemsPerSection, transitionTimerInMs) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const totalSections = Math.ceil(itemsLength / itemsPerSection);
  const isLastSection = currentIndex === totalSections - 1;
  const fireEvent = useAnalyticsEvents();
  const handleSlideChange = useCallback((newIndex, actionSubject) => {
    fireEvent({
      eventType: CarouselClickEvent,
      actionSubjectId: actionSubject,
      attributes: {
        currentIndex,
        newIndex,
        itemsLength
      }
    });
    setCurrentIndex(newIndex);
    setTransitioning(true);
    setTimeout(() => {
      setTransitioning(false);
    }, transitionTimerInMs);
  }, [transitionTimerInMs, currentIndex, fireEvent]);
  const handlePrev = useCallback(actionSubject => {
    const newIndex = currentIndex === 0 ? totalSections - 1 : currentIndex - 1;
    handleSlideChange(newIndex, actionSubject !== null && actionSubject !== void 0 ? actionSubject : ACTION_SUBJECT_ID_PREV_BUTTON);
  }, [currentIndex, handleSlideChange, totalSections]);
  const handleNext = useCallback(actionSubject => {
    const newIndex = currentIndex === totalSections - 1 ? 0 : currentIndex + 1;
    handleSlideChange(newIndex, actionSubject !== null && actionSubject !== void 0 ? actionSubject : ACTION_SUBJECT_ID_NEXT_BUTTON);
  }, [currentIndex, handleSlideChange, totalSections]);

  /* Accessibility focus management */
  const leftArrowRef = useRef(null);
  const focusButtonRef = useRef(null);
  const goToLeftArrowControl = useCallback(() => {
    if (leftArrowRef.current) {
      leftArrowRef.current.focus();
    }
  }, [leftArrowRef]);
  const handleFocusButtonPress = useCallback(event => {
    if ((event.key === 'Enter' || event.key === 'Spacebar') && !event.shiftKey) {
      event.preventDefault();
      goToLeftArrowControl();
    }
  }, [goToLeftArrowControl]);
  return {
    currentIndex,
    itemsPerSection,
    handleSlideChange,
    totalSections,
    isLastSection,
    handlePrev,
    handleNext,
    transitioning,
    goToLeftArrowControl,
    handleFocusButtonPress,
    leftArrowRef,
    focusButtonRef
  };
};
export function useSwipe(onSwipeLeft, onSwipeRight) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const minSwipeDistance = 50;
  const onTouchStart = e => {
    touchEndX.current = null;
    touchStartX.current = e.targetTouches[0].clientX;
  };
  const onTouchMove = e => {
    touchEndX.current = e.targetTouches[0].clientX;
  };
  const onTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null && Math.abs(touchStartX.current - touchEndX.current) > minSwipeDistance) {
      if (touchStartX.current > touchEndX.current) {
        onSwipeLeft(ACTION_SUBJECT_ID_SWIPE_LEFT);
      } else {
        onSwipeRight(ACTION_SUBJECT_ID_SWIPE_RIGHT);
      }
    }
  };
  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
}
// eslint-disable-next-line max-lines-per-function
export const Carousel = _ref11 => {
  let {
    children,
    itemsPerSection,
    slideTransitionTimeInMs = SLIDE_TRANSITION_TIME_IN_MS,
    autoScroll = false,
    autoScrollIntervalInSeconds = 5,
    showBackground = false
  } = _ref11;
  // Track when auto-scroll should pause (tab hidden or user focusing inside carousel)
  const [isPaused, setIsPaused] = useState(false);
  const containerRef = useRef(null);
  const items = React.Children.toArray(children);
  const displayCarousel = items.length > 1;
  const transitionTimerInMs = slideTransitionTimeInMs || SLIDE_TRANSITION_TIME_IN_MS;
  const {
    currentIndex,
    handleSlideChange,
    handlePrev,
    handleNext,
    transitioning,
    goToLeftArrowControl,
    handleFocusButtonPress,
    leftArrowRef,
    focusButtonRef
  } = useCarouselNavigation(items.length, itemsPerSection, transitionTimerInMs);
  const fireEvent = useAnalyticsEvents();
  const viewedSlides = useRef(new Set());

  /* ---------------- Pause handling ------------------ */
  // Pause when the browser tab / window is not visible
  useEffect(() => {
    const handleVisibility = () => {
      setIsPaused(document.visibilityState !== 'visible');
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);

  // Pause when any element inside the carousel gains focus; resume when focus leaves
  useEffect(() => {
    const node = containerRef.current;
    if (!node) {
      return;
    }
    const onFocusIn = () => setIsPaused(true);
    const onFocusOut = e => {
      if (!node.contains(e.relatedTarget || null)) {
        setIsPaused(false);
      }
    };
    node.addEventListener('focusin', onFocusIn);
    node.addEventListener('focusout', onFocusOut);
    return () => {
      node.removeEventListener('focusin', onFocusIn);
      node.removeEventListener('focusout', onFocusOut);
    };
  }, []);
  const swipeHandlers = useSwipe(handleNext, handlePrev);

  /* Keep a ref to the latest handleNext so the interval callback is always
   * up-to-date without needing to recreate the interval on every render. */
  const handleNextRef = useRef(handleNext);
  useEffect(() => {
    handleNextRef.current = handleNext;
  }, [handleNext]);
  useEffect(() => {
    if (!transitioning && !viewedSlides.current.has(currentIndex)) {
      fireEvent({
        eventType: CarouselSlideViewEvent,
        actionSubjectId: ACTION_SUBJECT_ID_SLIDE,
        attributes: {
          slideIndex: currentIndex,
          totalSlides: items.length
        }
      });
      viewedSlides.current.add(currentIndex);
    }
  }, [currentIndex, transitioning, items.length, itemsPerSection, fireEvent]);
  useEffect(() => {
    var _Number;
    if (!autoScroll || !displayCarousel || isPaused) {
      return;
    }
    const intervalMs = ((_Number = Number(autoScrollIntervalInSeconds)) !== null && _Number !== void 0 ? _Number : 5) * 1000;
    const id = setInterval(() => {
      // Treat auto-scroll as "next". This will wrap to first slide when at the end.
      handleNextRef.current(ACTION_SUBJECT_ID_AUTO_SCROLL);
    }, intervalMs);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoScroll, autoScrollIntervalInSeconds, displayCarousel, isPaused]);

  // When background is disabled we override the background-image via the inline style prop.
  const containerStyleOverride = showBackground ? undefined : {
    backgroundImage: 'none'
  };
  return /*#__PURE__*/_jsx(CarouselContainerStyle, _objectSpread(_objectSpread({
    ref: containerRef,
    displayCarousel: displayCarousel
  }, swipeHandlers), {}, {
    "data-testid": "carousel-container",
    style: containerStyleOverride,
    children: /*#__PURE__*/_jsxs(CarouselContentStyle, {
      "data-testid": "carousel-content",
      children: [displayCarousel && /*#__PURE__*/_jsxs(ArrowsContainer, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_84, _24, _85, _11, _86, _87, _88, _89, _20, _90]
          }), /*#__PURE__*/_jsx("button", {
            onClick: () => handlePrev(ACTION_SUBJECT_ID_PREV_BUTTON),
            ref: leftArrowRef,
            className: ax(["_1yt4u2gc _zulpu2gc _11q71bhr _2rko1ssb _19it1eso _lcxv1rj4 _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
            style: {
              "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
              "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
            },
            children: /*#__PURE__*/_jsx(ChevronLeftIcon, {
              label: "Previous section",
              size: "small"
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_84, _24, _85, _11, _86, _87, _88, _89, _20, _90]
          }), /*#__PURE__*/_jsx("button", {
            onClick: () => handleNext(ACTION_SUBJECT_ID_NEXT_BUTTON),
            className: ax(["_1yt4u2gc _zulpu2gc _11q71bhr _2rko1ssb _19it1eso _lcxv1rj4 _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
            style: {
              "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
              "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
            },
            children: /*#__PURE__*/_jsx(ChevronRightIcon, {
              label: "Next section",
              size: "small"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(CardsWrapper, {
        transitionTimerInMs: transitionTimerInMs,
        displayCarousel: displayCarousel,
        currentIndex: currentIndex,
        itemsPerSection: itemsPerSection,
        style: {
          transform: "translateX(-".concat(currentIndex * 100, "%)")
        },
        children: items.map((child, index) => /*#__PURE__*/_jsx(CardContainerStyle, {
          style: {
            visibility: index == currentIndex || transitioning ? 'visible' : 'hidden'
          },
          children: child
        }, index))
      }), /*#__PURE__*/_jsx(FocusButton, {
        displayCarousel: displayCarousel,
        ref: focusButtonRef,
        onClick: goToLeftArrowControl,
        onKeyDown: handleFocusButtonPress,
        "aria-label": "Tap to move through the carousel",
        children: /*#__PURE__*/_jsx(FocusButtonText, {
          children: "Tap to navigate"
        })
      }), /*#__PURE__*/_jsx(PaginationDots, {
        displayCarousel: displayCarousel,
        children: Array.from({
          length: items.length
        }).map((_, index) => /*#__PURE__*/_jsx(Dot, {
          tabIndex: -1,
          "data-testid": "pagination-dot-".concat(index + 1),
          active: index === currentIndex,
          onClick: () => handleSlideChange(index, ACTION_SUBJECT_ID_DOT)
        }, index))
      })]
    })
  }));
};